import { render } from "./UngDungAI.vue?vue&type=template&id=13a5defc"
import script from "./UngDungAI.vue?vue&type=script&lang=js"
export * from "./UngDungAI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__